export default function BasicInputLabel({label}) {
    return <label className="mb-1 font-bold text-lg">{label}</label>
}